export default {
  // Navigation
  'home': "మొదటి పేజీ",
  "detailed": "వివరణాత్మక జీవిత నివేదిక",
  "about": "గురించి", 
  "contact": "సంప్రదించండి",
  "get_reading": "రీడింగ్ పొందండి",
  "unlock_destiny": "మీ భవిష్యత్తును అన్‌లాక్ చేయండి",
  "language": "భాష",
  
  // Core Horoscope
  "core_horoscope": "ప్రధాన జాతకం",
  "birth_chart": "జన్మ నక్షత్రం / కుండలి",
  "match_kundli": "కుండలి జతపరచడం",
  "ascendant_analysis": "లగ్న విశ్లేషణ",
  "gochar_phal": "గోచర ఫలం",
  "dasha_analysis": "దశ ఫల విశ్లేషణ",
  "nakshatra_report": "నక్షత్ర నివేదిక",
  "numerology": "అంకశాస్త్రం",
  
  // Life Predictions
  "life_predictions": "జీవిత భవిష్యవాణులు",
  "your_life_predictions": "మీ జీవిత భవిష్యవాణులు",
  "2025_report": "2025 వ్యక్తిగత నివేదిక",
  "year_analysis": "సంవత్సర విశ్లేషణ",
  "daily_horoscope": "ఈరోజు నా దినం",
  "love_compatibility": "మీ ప్రేమ జీవితం",
  "career_guidance": "కెరీర్ మార్గదర్శనం",
  "nature_analysis": "మీ నిజమైన స్వభావం",
  "health_index": "ఆరోగ్య సూచిక",
  
  // Remedial Solutions
  "remedial_solutions": "పరిహార పరిష్కారాలు",
  "lal_kitab": "లాల్ కిताబ్ జాతకం",
  "mangal_dosha": "మంగళ దోష విశ్లేషణ",
  "kalsarp_dosh": "కాలసర్ప దోష నివేదిక",
  "sade_sati": "సాడే సాతి జీవిత నివేదిక",
  "ask_question": "ప్రశ్న అడగండి",
  "gemstones_report": "రత్నాల నివేదిక"
};
